// extracted by mini-css-extract-plugin
export default {"button":"Button_button__O+4gT","logo":"Button_logo__peMH-"};